import React from 'react';

import styles from './ReviewsPage.module.css';

type TProps = {
  children: React.ReactNode;
};

export const ReviewsPagePreview = ({ children }: TProps) => (
  <div className={styles.ReviewsPage__Preview}>{children}</div>
);
